import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import LoadsPage from "components/LoadsPage";
import {
  useAddOutsideTempLoadsMutation,
  useGetOutsideTempLoadsByCommunityIdPaginationQuery,
} from "state/hp/hpApiSlice";

function ManageOutsideTempLoads({ noWrapper }) {
  const { t } = useTranslation(["internalLoads"]);
  return (
    <LoadsPage
      title={t("pages.outside_temp_loads.title")}
      subtitle={t("pages.outside_temp_loads.subtitle")}
      taskType="OUTSIDE_TEMP_LOADS"
      templateHref="/docs/template_hp_outside_temperature.csv"
      addMutation={useAddOutsideTempLoadsMutation}
      noWrapper={noWrapper}
      table={{
        query: useGetOutsideTempLoadsByCommunityIdPaginationQuery,
        resourceField: "hp_id",
        resourceLabel: t("pages.outside_temp_loads.table.columns.hp"),
        resourceType: "HP",
        valueLabel: {
          field: "temperature",
          label: t("pages.outside_temp_loads.table.columns.temperature"),
        },
        valueDigits: 4,
      }}
    />
  );
}

ManageOutsideTempLoads.propTypes = {
  noWrapper: PropTypes.bool,
};

ManageOutsideTempLoads.defaultProps = {
  noWrapper: false,
};

export default ManageOutsideTempLoads;
